/**
 * MediaUploadPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Material UI components
import Paper from '@material-ui/core/Paper';

// application components
import ObjectEditPanel from "../editing/ObjectEditPanel";
import ObjectGrid from "../listing/ObjectGrid";

// application
import {duplicateObject, editObject, saveObject, cancelWithoutSaving} from "../../operations/editing";
import {openMediaOverlayForObject} from "../../operations/view";
import {deleteObject, searchTag} from "../../operations/listing";
import {selectObjectById, selectOriginalObjectById, selectCurrentObjectId} from "../../redux/editing/selectors";


/**
 * MediaUploadPage allows to upload new media files
 *
 * @author Jens Gruschel
 */
export class MediaUploadPage extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Paper className={classes.panel} elevation={1}>
                    <ObjectEditPanel
                        objectId={this.props.objectId}
                        objectType={this.props.object.type}
                        object={this.props.object}
                        originalObject={this.props.originalObject}
                        modified={this.props.modified[this.props.objectId]}
                        okButtonText={"save"}
                        onSaveObject={this.props.saveObject}
                        onCancel={this.props.cancelWithoutSaving}
                    />
                </Paper>
                <ObjectGrid
                    items={this.props.mediaItems}
                    onSelect={(index, object) => this.props.openMediaOverlayForObject(object)}
                    onDelete={(index, object) => this.props.deleteObject(object.id)}
                    onEdit={(index, object) => this.props.editObject(object.id)}
                    onDuplicate={(index, object) => this.props.duplicateObject(object.id)}
                    onSearchTag={this.props.searchTag}
                    pagination={true}
                />
            </div>
        );
    }Ø
}

const styles = {
    panel: {
        padding: "10px 0 10px 0",
        marginBottom: 30
    },
};

const mapStateToProps = state => {

    const objectId = selectCurrentObjectId(state.editing);

    return {
        objectId: objectId,
        object: selectObjectById(state.editing, objectId),
        originalObject: selectOriginalObjectById(state.editing, objectId),
        modified: state.editing.modified || {},
        mediaItems: state.editing.referencableObjects
    }
};

export default connect(mapStateToProps, {saveObject, openMediaOverlayForObject, editObject, deleteObject, searchTag, duplicateObject, cancelWithoutSaving})(withStyles(styles)(MediaUploadPage));
